<template>
  <div class="news-container">
    <div class="title">
      <!-- <span class="text">游戏情报</span> -->
      <img class="img-text" src="@/assets/images/yxqb.png" alt="" />
      <a class="more" href="/news" target="_blank" @click="handleBury">更多</a>
    </div>
    <div class="box">
      <div class="box-l">
        <a
          class="video-item"
          target="_blank"
          :href="
            getJumpWikiDetailUrl(
              (videoList[0] && videoList[0].game.alias) || 'www',
              videoList[0] && videoList[0].game.id,
              videoList[0] && videoList[0].content && videoList[0].content.id
            )
          "
          @click="handleBury"
        >
          <template v-if="videoList[0] && videoList[0].content && videoList[0].content.video[0]">
            <video
              ref="video1"
              muted
              disablePictureInPicture
              loop
              playsinline
              webkit-playsinline
              x5-playsinline
              :src="videoList[0].content.video[0].video"
              :poster="videoList[0].content.video[0].cover"
            ></video>
            <div class="info-box">
              <div class="title">{{ videoList[0].content.title }}</div>
              <div class="desc">{{ videoList[0].content.summary }}</div>
            </div>
          </template>
        </a>
      </div>
      <div class="box-r">
        <a
          class="news-item"
          v-for="item in newsList.slice(0, 3)"
          :key="item.id"
          :href="getJumpWikiDetailUrl(item.game_alias || 'www', item.game_id, item.id)"
          :title="item.game.name + item.title"
          target="_blank"
          @click="handleBury"
        >
          <div class="cover">
            <img v-lazy="handleImgSize(item.thumb.split(',')[0], 'icon')" :alt="item.game.name + item.title" />
          </div>
          <div class="info">
            <div class="title">{{ item.title }}</div>
            <!-- <div class="desc">{{ item.summary }}</div> -->
            <div class="desc">
              <span class="date-time"> {{ formatTime(item.created_at) }}</span>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="box">
      <div class="box-l">
        <a
          class="news-item"
          v-for="item in newsList.slice(3, 6)"
          :key="item.id"
          :href="getJumpWikiDetailUrl(item.game_alias || 'www', item.game_id, item.id)"
          :title="item.game.name + item.title"
          target="_blank"
          @click="handleBury"
        >
          <div class="cover">
            <img v-lazy="handleImgSize(item.thumb.split(',')[0], 'icon')" :alt="item.game.name + item.title" />
          </div>
          <div class="info">
            <div class="title">{{ item.title }}</div>
            <!-- <div class="desc">{{ item.summary }}</div> -->
            <div class="desc">
              <span class="date-time"> {{ formatTime(item.created_at) }}</span>
            </div>
          </div>
        </a>
      </div>
      <div class="box-r">
        <a
          class="video-item"
          target="_blank"
          :href="
            getJumpWikiDetailUrl(
              (videoList[1] && videoList[1].game.alias) || 'www',
              videoList[1] && videoList[1].game.id,
              videoList[1] && videoList[1].content && videoList[1].content.id
            )
          "
          @click="handleBury"
        >
          <template v-if="videoList[1] && videoList[1].content && videoList[1].content.video[0]">
            <video
              ref="video2"
              muted
              disablePictureInPicture
              loop
              :src="videoList[1].content.video[0].video"
              :poster="videoList[1].content.video[0].cover"
            ></video>
            <div class="info-box">
              <div class="title">{{ videoList[1].content.title }}</div>
              <div class="desc">{{ videoList[1].content.summary }}</div>
            </div>
          </template>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { getJumpWikiDetailUrl } from "@/plugins/util";

export default {
  name: "NewsContainer",
  props: {
    newsList: {
      type: Array,
      default: () => []
    },
    videoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  mounted() {
    if (this.$refs.video1) {
      this.observerVideoIntersection(this.$refs.video1);
    }
    if (this.$refs.video2) {
      this.observerVideoIntersection(this.$refs.video2);
    }
  },

  methods: {
    dayjs,
    getJumpWikiDetailUrl,
    handleBury() {
      if (window.staticFn) {
        console.log("点击", "click_new_game_information");
        if (this.$route.name === "wwwNewHome") {
          window.staticFn.customEvent("click_new_game_information");
        }
      }
    },
    formatTime(time) {
      const now = dayjs();
      const dateTime = dayjs.unix(time);
      if (now.diff(dateTime, "day") > 8) {
        return dateTime.format("YYYY年MM月DD日");
      } else if (now.diff(dateTime, "day") >= 1) {
        return now.diff(dateTime, "day") + "天前";
      } else if (now.diff(dateTime, "hour") >= 1) {
        return now.diff(dateTime, "hour") + "小时前";
      } else if (now.diff(dateTime, "minute") >= 1) {
        return now.diff(dateTime, "minute") + "分钟前";
      } else {
        return "刚刚更新";
      }
    },
    observerVideoIntersection(videoPlayer) {
      const observer = new IntersectionObserver(entries => {
        // 当目标元素进入或离开视口时，会触发回调函数
        entries.forEach(entry => {
          // 如果目标元素进入视口
          if (entry.isIntersecting) {
            // 在这里可以执行进入视口后的操作
            // videoPlayer.setAttribute("autoplay", true);
            videoPlayer.play();
          } else {
            // console.log('out', videoPlayer)
            // 在这里可以执行离开视口后的操作
            // videoPlayer.setAttribute("autoplay", false);
            videoPlayer.pause();
          }
        });
      });

      // 开始观察目标元素
      observer.observe(videoPlayer);
    }
  }
};
</script>

<style lang="less" scoped>
.news-container {
  margin-bottom: 70px;
  & > .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 38px;
    .text {
      font-family: CKTKingKong, CKTKingKong;
      font-weight: bold;
      font-size: 30px;
      color: #000000;
      text-shadow: 2px 2px 0px #13bdff;
    }
    .img-text {
      height: 28px;
    }
    .more {
      width: 57px;
      height: 30px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #d7d7d7;
      font-weight: 400;
      font-size: 16px;
      color: #444444;
      text-align: center;
      line-height: 30px;
    }
  }

  .box {
    display: flex;
    gap: 53px;
    padding-bottom: 50px;
    border-bottom: 1px solid #f1f1f1;
    margin-bottom: 50px;
    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
    .video-item {
      position: relative;
      display: flex;
      width: 711px;
      height: 400px;
      border-radius: 20px 20px 20px 20px;
      overflow: hidden;
      background: #e3e3e3;
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .info-box {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 711px;
        height: 117px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.33) 0%, rgba(0, 0, 0, 0.4) 100%);
        border-radius: 0px 0px 20px 20px;
        padding: 17px 15px 21px;
        backdrop-filter: blur(10px);
        .title {
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
          line-height: 28px;
          margin-bottom: 9px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .desc {
          height: 42px;
          font-weight: 400;
          font-size: 15px;
          color: #d5d5d5;
          line-height: 21px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          overflow: hidden;
          padding: 0 10px;
        }
      }
    }

    .news-item {
      display: flex;
      align-items: center;
      gap: 20px;
      padding-bottom: 24px;
      border-bottom: 1px solid #f1f1f1;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
      }
      .cover {
        flex-shrink: 0;
        width: 180px;
        height: 101px;
        border-radius: 10px 10px 10px 10px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all 0.2s;
          &:hover {
            transform: scale(1.05);
          }
        }
      }

      .info {
        height: 101px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          display: block;
          height: 44px;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          // 两行省略
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
        }
        .desc {
          .date-time {
            font-weight: 400;
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
